<script setup lang="ts">
const article = inject(keys.currentArticle)
</script>

<template>
  <h1 class="font-headline hyphens-auto md:hyphens-manual" v-html="article?.title" />
</template>
